import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";



// components
import PaymentMethodForm from "./_form";
import PaymentMethodFilters from "./_filters";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {GenericButton} from "../../../components/buttons/customButtons";

// labels
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";
import {LB_ACTIONS, LB_NAME, LIST, NO_DATA_FOUND} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {paymentMethodService} from "../../../jwt/_services/configuration/paymentMethodService";

// utils
import {getStateByPath} from "../../../redux/selectors";




const PaymentMethodList = (props) => {
    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};


    useEffect( () => {
        if(filter)
            return

        props.setFilter(path, {
            item: { code: null }
        })
    }, []);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, paymentMethodService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(PaymentMethodForm, { path, data })
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(PaymentMethodForm, { path })
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        service: paymentMethodService,
        remove : genericIndexedActions.delete,
    } );

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            hidden: true
        }, {
            dataField: 'name',
            text: `${LB_NAME}`,
        }, {
            dataField: 'xapiId',
            text: `XapiID`,
            headerStyle: {width: '30px'},
            headerAlign: 'center',
            align: 'center',
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: `${LB_ACTIONS}`,
            headerAlign: 'center',
            align: 'center',
            headerStyle: {width: '195px'},
            formatter: (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>
        }];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>

        <PaymentMethodFilters path={path}/>

        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(PaymentMethodList);